module.exports = __webpack_public_path__ + "img/base.346f2e48.svg";